// @ts-nocheck
import React from 'react';
import ReactDOM from 'react-dom';
import { AppContext } from 'src/providers/AppContextProvider';
import { IAppContextState } from 'src/reducers/AppContext';
import Button from '../redesign/FormButton';
import JSONPretty from 'react-json-pretty';

interface IFormErrorProps {
    endPoint?: string;
    error: Error | string;
    message?: string;
    result?: unknown;
}

const FormErrorStack: React.FC<{}> = (props) => {
    return ReactDOM.createPortal(props.children, document.querySelector('#admin-error-portal'));
};

const FormError: React.FC<IFormErrorProps> = (props) => {
    const appContext = React.useContext<IAppContextState>(AppContext);
    const [showStack, setShowStack] = React.useState(false);

    const sessionBody = localStorage.getItem('lastApiBody');

    const jsonBody = sessionBody !== 'undefined' ? JSON.parse(sessionBody) : {};

    const renderErrorStack = () => {
        return (
            <div
                style={{
                    borderRadius: '5px',
                    position: 'fixed',
                    top: '0',
                    left: '0',
                    width: 'calc(100vw - 6rem)',
                    height: 'calc(100vh - 6rem)',
                    margin: '3rem',
                    background: 'white',
                    padding: '3rem',
                    zIndex: 1100,
                    overflow: 'auto',
                }}
            >
                <Button intent="primary" text="Hide Stack" onClick={() => setShowStack(false)} />
                <hr />
                <h4>{props.message}</h4>
                {/* <div>
                    <span style={{ fontWeight: 'bold' }}>Message: </span>
                    <pre>{props.error}</pre>
                </div> */}
                <div>
                    <span style={{ fontWeight: 'bold' }}>Url: </span>
                    <pre>{localStorage.getItem('lastApiCall')}</pre>
                </div>
                <div>
                    <span style={{ fontWeight: 'bold' }}>Body: </span>
                    <pre>
                        <JSONPretty data={jsonBody} />
                    </pre>
                </div>
                <div>
                    <span style={{ fontWeight: 'bold' }}>Stack: </span>
                    <pre>{JSON.stringify(props.error, null, 2)}</pre>
                </div>
            </div>
        );
    };

    if (!props.error) {
        return <></>;
    }

    return (
        <>
            <div style={{ display: 'table', padding: '1rem', border: '1px solid red', marginBottom: '1rem', width: '100%', background: '#ffffcc' }}>
                <div style={{ margin: 'auto', verticalAlign: 'center', textAlign: 'center' }}>
                    <div style={{ fontWeight: 'bold' }}>{props.message || 'Unexpected Error'}</div>
                    {appContext.currentUser.isAdmin && (
                        <Button className="mt-2" intent="primary" text="Show Stack" onClick={() => setShowStack(true)} />
                    )}
                </div>
            </div>
            {showStack && <FormErrorStack>{renderErrorStack()}</FormErrorStack>}
        </>
    );
};

export default FormError;



// WEBPACK FOOTER //
// ./src/components/controls/forms/common/FormError.tsx